module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/content.component.html
// module id = ./src/app/main/content/content.component.html
// module chunks = main